import React, { createRef, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import SVG from 'react-inlinesvg';
import config from '../../../../../common-sk-doc/src/config';

const BookExtraResourceCustom: React.FC<{
  extraResourceGroup: any;
}> = ({ extraResourceGroup }) => {
  const [extend, setExtend] = useState(false);
  const ref = createRef<HTMLDivElement>();
  const handleClick = () => {
    if (extraResourceGroup.extraResources?.length === 1) {
      window.open(extraResourceGroup.extraResources[0].link, '_blank');
    } else {
      setExtend(!extend);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setExtend(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
  return (
    <div
      className="extra-resource"
      style={
        extraResourceGroup.extraResources?.length > 0 ? {} : { display: 'none' }
      }>
      <div className="top-icon" onClick={handleClick}>
        <SVG src={config.ASSETS_PATH + extraResourceGroup.icon} />
        <span>{extraResourceGroup.key}</span>
        <FontAwesomeIcon
          icon={!extend ? faCaretDown : faCaretUp}
          style={{
            visibility:
              extraResourceGroup.extraResources?.length === 1
                ? 'hidden'
                : 'visible',
          }}
        />
      </div>
      {extend && (
        <div className="extra-resource-extend" ref={ref}>
          {extraResourceGroup.extraResources.map((i, index) => (
            <a key={index} href={i.link} target="_blank" rel="noreferrer">
              {i.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookExtraResourceCustom;
